import { useRequestData } from 'wsm-common-data';
import { useSelector } from 'react-redux';
import generateUID from '../utilities/generateUID';

export default function useUID() {
	const { windowId } = useRequestData();
	const { pageAlias } = useSelector((state) => state.widgetData);
	return generateUID(`${windowId}_${pageAlias}`);
}
